module.exports = __webpack_public_path__ + "img/eatDoradoAppIcon.b28b3126.png";